import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { monthShortFormatter, dayOfMonthFormatter } from '@amtrav/dates';
import { getTokenValue, THEME_TOKENS } from '@amtrav/theme-system';

const DateDisplayContainer = styled.div`
  display: inline-block;
  border-style: solid;
  border-width: 1px;
  border-color: ${getTokenValue(THEME_TOKENS.base.color.infoBorder)};
  border-radius: ${getTokenValue(THEME_TOKENS.card.size.borderRadiusMedium)};
  overflow: hidden;
`;

const MonthContainer = styled.div`
  background-color: ${getTokenValue(THEME_TOKENS.base.color.neutral900)};
  color: white;
  display: flex;
  justify-content: center;
  padding: 4px 12px;
  text-transform: uppercase;
  font-weight: 600;
  letter-spacing: 1.4px;
  font-size: 10px;
  margin: -1px -1px 0;
  min-width: 52px;
`;

const DateContainer = styled.div`
  background-color: white;
  color: ${getTokenValue(THEME_TOKENS.base.color.neutral900)};
  display: flex;
  justify-content: center;
  font-size: 24px;
  font-weight: bold;
  padding: 8px;
`;

export const DateDisplay = ({ date }) => {
  const dateString = date.toString();
  const year = dateString.substring(0, 4);
  const month = dateString.substring(4, 6);
  const day = dateString.substring(6, 8);
  const dateObject = new Date(year, month - 1, day);

  return (
    <div>
      <DateDisplayContainer>
        <MonthContainer>{monthShortFormatter(dateObject)}</MonthContainer>
        <DateContainer>{dayOfMonthFormatter(dateObject)}</DateContainer>
      </DateDisplayContainer>
    </div>
  );
};

DateDisplay.propTypes = {
  date: PropTypes.number,
};
